import * as React from 'react';
import type { LexicalComposerContextWithEditor } from '@fluentui-copilot/react-text-editor';
import { createLexicalComposerContext } from '@fluentui-copilot/react-text-editor';
import type { EditorInputContextValues, EditorInputState } from './EditorInput.types';

export function useEditorInputContextValues(state: EditorInputState): EditorInputContextValues {
  const { lexicalInitialConfig, lexicalEditor } = state;
  const { theme } = lexicalInitialConfig;

  const context: LexicalComposerContextWithEditor = React.useMemo(
    () => [lexicalEditor, createLexicalComposerContext(null, theme)],
    [lexicalEditor, theme],
  );

  return { lexicalComposer: context };
}
